import { render, staticRenderFns } from "./Hired.vue?vue&type=template&id=40d5a4a8&"
import script from "./Hired.vue?vue&type=script&lang=js&"
export * from "./Hired.vue?vue&type=script&lang=js&"
import style0 from "./Hired.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports